import styled from "styled-components";

// ขนาดคอลัมน์ของสรุปยอด ใช้คำนวณให้ยอดเงินแถวสลิปตรงแนว "Added by admin"
const LABEL_W = 250;
const BOX_W = 185;
const BOX_MR = 93;
const GAP = 30;
const VALUE_COL_X = LABEL_W + GAP + BOX_W + BOX_MR + GAP;

export const PaymentInfoStyled = styled.div`
  .paymentinfo_row {
    margin-bottom: 22px;
    display: flex;
    justify-content: space-between;
    column-gap: 30px;
    .paymentinfo_text1 {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S17};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }
  /* Add Payment อยู่ใต้แถบสถานะ ชิดขวา */
  .paymentinfo_add_row {
    margin-bottom: 32px;
    display: flex;
    justify-content: flex-end;
  }
  .paymentinfo_status_block {
    margin-bottom: 12px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    padding: 3px;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.COLORS.GRAY_14};
    .paymentinfo_text2 {
      flex: 1;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S17};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    /* เลขขั้นตอนหน้าปุ่ม (3.2 / 4) สีตามวงกลม step ด้านบน ทรง pill เพราะ "3.2" กว้างกว่าวงกลม */
    .btn_step_no {
      margin-right: 4px;
      flex-shrink: 0;
      min-width: 18px;
      height: 18px;
      padding: 0 4px;
      box-sizing: border-box;
      border-radius: 9px;
      border: 1px solid ${({ theme }) => theme.COLORS.BLACK_1};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: ${({ stepBgColor }) => stepBgColor};
      color: ${({ stepTxtColor }) => stepTxtColor};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      line-height: 1;
    }
    /* สีม่วงเฉพาะตอนมีงานให้กดปุ่มนี้ เหมือนปุ่ม Edit/Action ของ Status */
    &.is_action .theme_edit_action .btn {
      background: #d9bafa;
    }
  }
  .paymentinfo_detail {
    margin-bottom: 42px;
    .paymentinfo_row_date1 {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      column-gap: ${GAP}px;
      .paymentinfo_row_left {
        width: ${VALUE_COL_X - GAP}px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        column-gap: ${GAP}px;
      }
      .paymentinfo_date_text1 {
        flex-basis: 150px;
        flex-shrink: 0;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      .paymentinfo_date_text2 {
        min-width: 220px;
        color: ${({ theme }) => theme.COLORS.GREEN_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      }
      .paymentinfo_date_text3 {
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
        /* ยอดเงินตัวใหญ่สีน้ำเงิน ให้แอดมินเห็นชัด */
        .paymentinfo_amount {
          color: ${({ theme }) => theme.COLORS.BLUE_3};
          font-size: ${({ theme }) => theme.FONT.SIZE.S22};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
        }
        .paymentinfo_amount_note {
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        }
      }
    }
  }
  /* สรุปยอด: label | ตัวเลขชิดขวา | คอลัมน์ข้าง (ตรงแนวยอดเงินแถวสลิปด้านบน) */
  .paymentinfo_summary {
    margin-bottom: 32px;
    .ps_row {
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      column-gap: ${GAP}px;
      .ps_label {
        flex-basis: ${LABEL_W}px;
        flex-shrink: 0;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        .ps_label_note {
          margin-top: 2px;
          color: ${({ theme }) => theme.COLORS.GRAY_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        }
      }
      .ps_value {
        margin-right: ${BOX_MR}px;
        width: ${BOX_W}px;
        flex-shrink: 0;
        text-align: right;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S18};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      .ps_side {
        .paymentinfo_date {
          margin-bottom: 2px;
          color: ${({ theme }) => theme.COLORS.BLACK_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        }
        .paymentinfo_date2 {
          color: ${({ theme }) => theme.COLORS.GRAY_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        }
      }
      .ps_hint {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      &.ps_total .ps_label,
      &.ps_total .ps_value {
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      }
      &.ps_paid .ps_value {
        color: ${({ theme }) => theme.COLORS.BLUE_3};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      }
      &.ps_outstanding .ps_label,
      &.ps_outstanding .ps_value {
        color: ${({ theme }) => theme.COLORS.RED_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      }
    }
    /* เส้นคั่นยาวเท่า label + ตัวเลข */
    .ps_divider {
      margin: 4px 0 18px;
      width: ${VALUE_COL_X - GAP - BOX_MR}px;
      border-top: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    }
  }
  .paymentinfo_adminnote {
    margin-bottom: 18px;
    display: flex;
    column-gap: 30px;
    .paymentinfo_note_title {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .spaymentinfo_note_detail {
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }

  .theme_standard {
  }
`;
